import { FileUploadModel } from 'app/shared/file-upload/model/file-upload.model';
import axios from 'axios';
import { FileWrapper } from 'app/shared/model/shared.model';

export const uploadActFile = async (idCaseAct: string, file: FileUploadModel): Promise<any> => {
  const formData: FormData = new FormData();

  formData.append('file', file.file);
  formData.append('fileName', file.fileName);
  formData.append('uuid', file.uuid);

  return await new Promise((resolve, reject) => {
    axios
      .post(`api/cases/case-acts/files/${idCaseAct}`, formData)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const fetchCaseActAttachments = async (
  idCaseAct: string,
  page: number,
  size: number,
  column: string,
  direction: string,
): Promise<any> => {
  if (idCaseAct) {
    return await new Promise(resolve => {
      axios
        .get(`api/cases/case-acts/files/find-all/${idCaseAct}?page=${page}&size=${size}&column=${column}&direction=${direction}`)
        .then(response => resolve(response.data));
    });
  }
};

export const deleteCaseActAttachment = async (idCaseActAttachment: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .delete(`api/cases/case-acts/files/delete-attachment/${idCaseActAttachment}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const previewCaseActAttachment = async (idCaseActAttachment: number): Promise<FileWrapper> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/case-acts/files/preview-attachment/${idCaseActAttachment}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const previewCaseActWorkingVersionFileWithDefaultTemplate = async (idCase: string): Promise<FileWrapper> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/cases/${idCase}/case-acts/default-template/preview-working-version-file`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};


export const previewAmendmentCaseActWorkingVersionFileWithDefaultTemplate = async (idCase: string): Promise<FileWrapper> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/cases/${idCase}/case-acts/amendment-default-template/preview-working-version-file`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const generateEarhivaConfirmation = async (caseUuid: string): Promise<FileWrapper> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/${caseUuid}/earhiva-confirmation`)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};
